module.exports = __webpack_public_path__ + "img/expression.0a4dddd3.svg";